import { ButtonHTMLAttributes, DetailedHTMLProps, FC } from "react";
import { WalletModalConnector } from ".";
import { InternalConnector } from "../../Models/WalletProvider";
import { Loader } from "lucide-react";
import { resolveWalletConnectorIcon } from "@/lib/wallets/utils/resolveWalletIcon";
import { Badge } from "@/components/shadcn/badge";

type Connector = DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
    connector: InternalConnector,
    connectingConnector?: WalletModalConnector
    isRecent?: boolean
    onClick: () => void
    isProviderReady?: boolean
}

const Connector: FC<Connector> = ({ connector, connectingConnector, onClick, isRecent, isProviderReady = true, ...props }) => {
    const connectorName = connector?.name
    const connectorId = connector?.id

    const Icon = resolveWalletConnectorIcon({ connector: connectorId, iconUrl: connector.icon })
    const isLoading = connectingConnector?.name === connectorName

    return (
        <>
            <button
                type="button"
                disabled={!!connectingConnector || !isProviderReady}
                className="w-full h-fit flex items-center justify-between bg-secondary-500 hover:bg-secondary-400 transition-colors duration-200 rounded-xl p-3 disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={onClick}
                {...props}
            >
                <div className="flex gap-2.5 items-center font-medium w-full">
                    <div className="w-11">
                        <Icon className="w-11 h-auto p-0.5 rounded-[10px] bg-secondary-800" />
                    </div>
                    <div className='flex flex-col items-start justify-center col-start-2 col-span-3 min-h-[40px] truncate'>

                        <p className='text-base text-left truncate w-full'>{connectorName}</p>
                        {
                            connector.type === 'injected' && !isRecent &&
                            <Badge variant="ghost" className="text-secondary-text hover:bg-transparent">Installed</Badge>
                        }
                        {
                            isRecent &&
                            <Badge variant="secondary" className="text-secondary-text bg-secondary-100">Recent</Badge>
                        }
                    </div>
                    {
                        isLoading &&
                        <div className='absolute right-0 bg-secondary-800 rounded-lg p-1'>
                            <Loader className='h-4 w-4 animate-spin' />
                        </div>
                    }
                </div>
            </button>
        </>
    )
}

export default Connector